import React from 'react';
import { Container, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import VehicleManagementTable from '../../components/tables/VehicleManagementTable/VehicleManagementTable';
import { useAuth } from '../../contexts/AuthContext';
import './VehicleManagement.css';

const VehicleManagement = () => {
    const navigate = useNavigate();
    const { hasRole } = useAuth();

    const handleAddVehicle = () => {
        navigate('/vehicle-management/add-new');
    };

    return (
        <Container fluid>
            <ToastContainer />
            <div className="vehicle-management-page">
                <div className="d-flex justify-content-between align-items-center mt-5 mb-4">
                    <h3>Vehicle Management</h3>
                    {hasRole(['admin', 'it', 'vh-manager', 'vh-user', 'car-manager']) && (
                        <Button onClick={handleAddVehicle} variant="primary">
                            Add Vehicle
                        </Button>
                    )}
                </div>
                <VehicleManagementTable />
            </div>
        </Container>
    );
};

export default VehicleManagement;
